'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = adsReducer;

var _actionTypes = require('../actions/action-types');

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  ads: [
    // adName: '',
    // sizes: [],
    // slotID: '',
    // device: '',
    // slot: {},
    // displayed: false
    // refreshable: false
  ],
  displayAboveTheFold: false,
  sequenceOrder: 1,
  settings: {},
  env: 'production',
  requestParams: {}
};

/**
 * Reducers related to ads
 * @param {Object} state of the application
 * @param {Object} action to be trigger
 * @returns {Object}
 */
function adsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case types.REGISTER_SLOT:
      return (0, _assign2.default)({}, state, state.ads.push((0, _extends3.default)({}, action.props)));
    case types.DEFINE_SLOT:
      return (0, _assign2.default)({}, state, {
        ads: state.ads.map(function (ad) {
          if (ad.slotID === action.id) {
            return (0, _assign2.default)({}, ad, { slot: action.slot });
          }
          return ad;
        })
      });
    case types.DISPLAY_AD:
      return (0, _assign2.default)({}, state, {
        ads: state.ads.map(function (ad) {
          if (ad.slotID === action.id) {
            return (0, _assign2.default)({}, ad, { displayed: true });
          }
          return ad;
        })
      });
    case types.DISPLAY_ADS_ABOVE_THE_FOLD:
      return (0, _assign2.default)({}, state, { displayAboveTheFold: true });
    case types.INCREASE_SEQUENCE:
      return (0, _assign2.default)({}, state, { sequenceOrder: state.sequenceOrder + 1 });
    case types.ADD_SETTINGS:
      return (0, _assign2.default)({}, state, { settings: action.settings });
    case types.ADD_ENV:
      return (0, _assign2.default)({}, state, { env: action.env });
    case types.ADD_REQUEST_PARAMS:
      return (0, _assign2.default)({}, state, { requestParams: action.requestParams });
    case types.ADD_CONTENT_TYPE:
      return (0, _assign2.default)({}, state, { contentType: action.contentType });
    case types.SET_NATIVE:
      return (0, _assign2.default)({}, state, { nativeCalled: true });
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/store/reducers/ads-reducer.js
// module id = 119
// module chunks = 35783957827783 71851226274881